import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-left-down', 'CornerLeftDown', [["path",{"d":"M10.027 19V9a4 4 0 0 1 4-4H19m-8.973 14 5.028-4.78M10.027 19 5 14.22","key":"svg-0"}]]);